import { useState } from "react";
import { faqs } from "@/mocks/clueData";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FaqAccordion() {
  const [active, setActive] = useState<number | null>(0);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-16 md:px-8 md:py-20">
        <SectionHeading
          align="center"
          eyebrow="常见问题"
          icon="ri-question-line"
          title="关于投稿，你可能想先知道"
          desc="以下是网友问得最多的几个问题，如果没有解答你的疑惑，欢迎通过联系页面留言。"
        />

        <div className="mx-auto mt-10 w-full max-w-3xl">
          <ul className="flex flex-col gap-3">
            {faqs.map((faq, index) => {
              const isOpen = active === index;
              return (
                <li
                  key={faq.q}
                  className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setActive(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                        {faq.q}
                      </span>
                      <i
                        className={`${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        } shrink-0 text-lg text-primary-600`}
                      ></i>
                    </button>
                  </h3>
                  {isOpen && (
                    <div className="border-t border-background-200 px-5 py-4">
                      <p className="text-sm leading-7 text-foreground-600">{faq.a}</p>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}